import { render, staticRenderFns } from "./PaymentDocumentTable.vue?vue&type=template&id=0f6641c8&"
import script from "./PaymentDocumentTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentDocumentTable.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDocumentTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
